export const PurchaseRequestIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 11.4453H8M10 15.4453H8M16 7.44531H8M20 10.9453V7.24531C20 5.56516 20 4.72508 19.673 4.08334C19.3854 3.51885 18.9265 3.05991 18.362 2.77229C17.7202 2.44531 16.8802 2.44531 15.2 2.44531H8.8C7.11984 2.44531 6.27976 2.44531 5.63803 2.77229C5.07354 3.05991 4.6146 3.51885 4.32698 4.08334C4 4.72508 4 5.56516 4 7.24531V17.6453C4 19.3255 4 20.1655 4.32698 20.8073C4.6146 21.3718 5.07354 21.8307 5.63803 22.1183C6.27976 22.4453 7.11984 22.4453 8.8 22.4453H11.5M22 22.4453L20.5 20.9453M21.5 18.4453C21.5 20.3783 19.933 21.9453 18 21.9453C16.067 21.9453 14.5 20.3783 14.5 18.4453C14.5 16.5123 16.067 14.9453 18 14.9453C19.933 14.9453 21.5 16.5123 21.5 18.4453Z"
        stroke="#99A0AE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
